import React, { useState, useEffect } from "react"
import cx from "classnames"
import _get from "lodash/get"
import { isMobile } from "react-device-detect"
import { NumericFormat } from "react-number-format"
import MissingImage from "@/public/images/image-missing.png"
import { addDataLayer } from "./ProductDetailView/analytics"
import Button from "@/components/core/Button/Button"
import { scroller } from "react-scroll"
import { getAsPDPThumbnail, getShortenedUrlwithGeneral } from "@/utils/helper"
import Link from "next/link"
import { SHIPS_IN_LABEL } from "@/constants/index";

const StickyHeader = props => {
  const [showBuyBoxArea, setShowBuyBoxArea] = useState(true)
  const [finalPrice, setFinalPrice] = useState(props.price)
  const [updatedFinalPrice, setItemFinalPrice] = useState(
    Number(localStorage?.getItem("itemFinalPrice") ?? 0)
  )
  const itemStatus = _get(props, "itemStatus", "available")
  let statusText = ""

  let buttonText =
    props.templateType === "tile" || props.templateType === "trim"
      ? props?.staticTexts?.calcAddCart
      : props.staticTexts.addToCart
  if (props.isColorDiscontinued) {
    buttonText = props.staticTexts.availColorCTA
  }
  if (
    itemStatus === "outOfStock" ||
    (!(props.productStock > 0) &&
      (props.specialOrder !== "Yes" || props.backOrder !== "Yes"))
  ) {
    statusText = props.staticTexts.outOfStock
    buttonText = props.staticTexts.notifyMailCTA
  } else if (itemStatus === "discontinued") {
    statusText = props.staticTexts.discontinued
    buttonText = props.staticTexts.findSimilar
  } else if (itemStatus === "preOrder") {
    buttonText = props.staticTexts.preOrder
  } else if (itemStatus === "specialOrder") {
    buttonText = props.staticTexts.specialOrder
  }

  const productCategoryType = props.productCategoryType ?? ""
  const isSamplesPdp = productCategoryType.toLowerCase() === "samples"

  useEffect(() => {
    if (updatedFinalPrice > 0) {
      setFinalPrice(updatedFinalPrice)
    }
  }, [updatedFinalPrice])

  useEffect(() => {
    const handleScroll = () => {
      const navEl = props.navData.map(el => document.getElementById(el.elemId))
      const navSize = isMobile && window.outerWidth < 1024 ? 63 : 163
      const windowTop = window.scrollY + navSize
      navEl.forEach((ele, i) => {
        if (ele) {
          const { offsetBottom, offsetTop } = getDimensions(ele)
          if (windowTop > offsetTop && windowTop < offsetBottom) {
            props.handleScrollNav(i)
          }
        }
      })
    }
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  useEffect(() => {
    if (props.productIsRetail) {
      setShowBuyBoxArea(false)
    } else if (!props?.price && !props?.disableEcommerce) {
      setShowBuyBoxArea(false)
    } else {
      setShowBuyBoxArea(true)
    }
  }, [props.productIsRetail, props.price])

  const getDimensions = ele => {
    const { height } = ele.getBoundingClientRect()
    const offsetTop = ele.offsetTop
    const offsetBottom = offsetTop + height

    return {
      height,
      offsetTop,
      offsetBottom,
    }
  }

  const handleNavChange = (navActive, value) => {
    props.handleNavChange(navActive)
    addDataLayer({
      title: "sticky nav links",
      isSticky: true,
      navTitle: value.toLowerCase(),
      productInfo: props?.analyticsProductInfo,
    })
  }

  const scrollToTrimBlock = (idInfo, e) => {
    e.preventDefault()
    addDataLayer({
      title: (idInfo === "email"
        ? props.staticTexts.notifyMailCTA
        : props.staticTexts?.addToCart
      ).toLowerCase(),
      productInfo: props?.analyticsProductInfo,
      isSticky: true,
    })
    scroller.scrollTo(idInfo, {
      duration: 1500,
      delay: 0,
      smooth: "easeInOutQuart",
      offset: -190,
    })
  }

  const handleStickyCart = () => {
    localStorage.setItem("headerAtcIsClicked", true)
    if (props?.replaceAddToCart) {
      document.querySelector(".ecommerce-cart__main-button")
        ? document.querySelector(".ecommerce-cart__main-button").click()
        : ""
    } else {
      document.querySelector(".add-to-cart__main-button")
        ? document.querySelector(".add-to-cart__main-button").click()
        : ""
    }
  }

  const AddToCartActionsMarkup = () => {
    return (
      <div className="sticky-header__cart-block">
        <Button
          id="sticky__add-to-cart"
          className="sticky__add-to-cart"
          label={props.staticTexts?.addToCart}
          size="small"
          type="primary"
          onClick={handleStickyCart}
        />
      </div>
    )
  }
  const handleAssetId = (imageUrl = "") => {
    const lastImageId = imageUrl?.split("/")?.pop()
    const res = lastImageId?.split("?")?.length
      ? lastImageId?.split("?")[0]
      : lastImageId
    return res
  }
  const preseterUrl = (imgUrl = "") =>
    getAsPDPThumbnail(
      props?.swatchUrl,
      props?.presetConfig,
      handleAssetId(imgUrl),
      props?.accountName
    )

  return (
    <div className="sticky-header container-fluid">
      <div className="sticky-header__details-wrap container-fluid">
        <div className="sticky-header__container container">
          <img
            onError={e => (e.target.src = MissingImage?.src)}
            src={preseterUrl(props.imgUrl)}
            alt={props.title}
          />
          <div className="sticky-header__details">
            <span className="sticky-header__brand-name">{props.title}</span>
          </div>
          <div className="sticky-header__rating-desc">
            <p className="sticky-header__description">{props.description}</p>
          </div>
          <div className="sticky-header__shape-desc">
            <span>{props.ProductDescriptionDetail_s}</span>
          </div>
          {props?.leadTimeRange && (
            <div className="sticky-header__shipping-time">
              <span>{SHIPS_IN_LABEL + " " + props?.leadTimeRange}</span>
            </div>
          )}
          {showBuyBoxArea && (
            <div
              className={cx({
                "sticky-header__right": true,
                "sticky-header__right--retailers": props.productIsRetail,
              })}
            >
              {itemStatus !== "discontinued" && (
                <div className="sticky-header__price-block">
                  <div
                    className="sticky-header__price-text"
                    id="sticky-header__price-text"
                  >
                    {props.productStock > 0
                      ? updatedFinalPrice > 0
                        ? props?.staticTexts?.calculatedTotal
                        : props?.staticTexts?.startingAt
                      : ""}
                  </div>
                  {!isSamplesPdp && (
                    <div className="sticky-header__price">
                      <NumericFormat
                        value={finalPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={props.currencySign}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        id="sticky-header__price"
                      />
                      <span className="sticky-header__price-type">
                        {updatedFinalPrice ? "" : props?.priceTag}
                      </span>
                    </div>
                  )}
                </div>
              )}
              {updatedFinalPrice > 0 &&
              props.productStock &&
              !props.disableEcommerce ? (
                <AddToCartActionsMarkup />
              ) : !(props.productStock > 0) &&
                (props.specialOrder === "Yes" ||
                  (props.backOrder === "Yes" &&
                    props.templateType !== "samples") ||
                  props.isParts) ? (
                <AddToCartActionsMarkup />
              ) : (
                <div className="sticky-header__cart-block">
                  {!props.disableEcommerce ? (
                    <Button
                      id="calc__add-to-cart-btn"
                      className={`calc__add-to-cart ${
                        !props.productStock ? "calc__notify-cart-btn" : ""
                      }`}
                      label={buttonText}
                      size="small"
                      type="primary"
                      onClick={
                        props.productStock
                          ? props.templateType === "grout"
                            ? handleStickyCart
                            : e =>
                                scrollToTrimBlock(
                                  "trim-calculator_main-block",
                                  e
                                )
                          : e => scrollToTrimBlock("email", e)
                      }
                      to={
                        props.productStock
                          ? props.templateType === "grout"
                            ? "javascript:void(0)"
                            : "#trim-calculator_main-block"
                          : "#email"
                      }
                    />
                  ) : (
                    props.replaceAddToCart && (
                      <Button
                        id="ecommerce-cart-btn"
                        className="calc__add-to-cart"
                        label={props.replaceAddToCartCtaLabel}
                        size="small"
                        type="primary"
                        flexible={true}
                        tag="anchor"
                        to={
                          props.replaceAddToCartCtaLink
                            ? getShortenedUrlwithGeneral(
                                props.replaceAddToCartCtaLink,
                                props.general
                              )
                            : "javascript:void(0)"
                        }
                        target={
                          props.linkNewTab === "true" ? "_blank" : "_self"
                        }
                        onClick={handleStickyCart}
                      />
                    )
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="sticky-header__nav-container container">
        <div className="sticky-header__nav-items">
          {props.navData.map((item, index) => (
            <Link
              key={index}
              href={item.elemId}
              className={item.isActive ? "sticky-nav-active" : ""}
              onClick={() => handleNavChange(index, item.label)}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default StickyHeader
